module.exports = __webpack_public_path__ + "img/upload-file-sample.3ac4e306.png";